import PeopleCircles from '@/components/PeopleCircles'
import type { Person } from '@/lib/person'

// Server props (Plan::CycleTaskProps#revision_submit_props): on the submit
// page only while the plan is published and no planning task is open on it.
export interface RevisionSubmit {
  plan_id: string
  default_reviewer_ids: string[]
  people: Person[]
}

// The submit page's right column for a revision of a published plan. There
// is no task yet (it is born on submit), so the reviewers are picked here —
// the cycle task's card carries them otherwise. An empty list publishes the
// changes right away.
export default function ReviewersCard({ people, selectedIds, onChange }: {
  people: Person[]
  selectedIds: string[]
  onChange: (ids: string[]) => void
}) {
  return (
    <div
      style={{ background: 'var(--background)', borderColor: 'var(--border)' }}
      className="min-w-0 flex-1 rounded-lg border p-5"
    >
      <h2 className="text-lg font-semibold leading-snug tracking-tight text-foreground">Reviewers</h2>
      <p className="mt-0.5 text-[13px] text-muted-foreground">
        Who approves these changes before they update the published plan.
      </p>
      <div className="mt-3">
        <PeopleCircles title="Reviewers" people={people} selectedIds={selectedIds} onChange={onChange} editable />
      </div>
      {selectedIds.length === 0 && (
        <p className="mt-2 text-[13px] text-warning">
          No reviewer picked — the changes will update the published plan right away.
        </p>
      )}
    </div>
  )
}
